import { render, staticRenderFns } from "./ModuleImages.vue?vue&type=template&id=52c8992b&scoped=true&"
import script from "./ModuleImages.vue?vue&type=script&lang=js&"
export * from "./ModuleImages.vue?vue&type=script&lang=js&"
import style0 from "./ModuleImages.vue?vue&type=style&index=0&id=52c8992b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8992b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Media: require('/vercel/path0/components/Media.vue').default})
